import { DEFAULT_WOD_MOVEMENT } from "./constants";

const movement = (overrides) => ({
    ...DEFAULT_WOD_MOVEMENT,
    ...overrides,
    scaling: {
        ...DEFAULT_WOD_MOVEMENT.scaling,
        ...(overrides.scaling || {}),
    },
});

export const WOD_BENCHMARK_GROUPS = [
    { value: "girls", label: "Girls" },
    { value: "heroes", label: "Heroes" },
    { value: "open", label: "Open" },
    { value: "engine", label: "Engine" },
    { value: "strength", label: "Strength" },
    { value: "box", label: "Box" },
];

export const WOD_BENCHMARK_LIBRARY = [
    {
        id: "cindy",
        name: "Cindy",
        group: "girls",
        track: "crossfit",
        format: "amrap",
        scoreType: "rounds_reps",
        timeCap: "20 min",
        stimulus: "Ritmo sustentável, transições curtas e volume ginástico acumulado.",
        equipment: ["Barra"],
        tags: ["benchmark", "bodyweight", "gymnastics"],
        blocks: [{
            name: "Cindy",
            workoutType: "wod",
            componentType: "metcon",
            format: "amrap",
            scoreType: "rounds_reps",
            timeCap: "20 min",
            stimulus: "Manter ritmo constante por 20 minutos.",
            sets: [
                movement({ movementId: "pull_up", movement: "Pull-up", category: "gymnastics", reps: 5, unit: "reps", scaling: { beginner: "Ring row" } }),
                movement({ movementId: "push_up", movement: "Push-up", category: "bodyweight", reps: 10, unit: "reps", scaling: { beginner: "Flexão elevada" } }),
                movement({ movementId: "air_squat", movement: "Air Squat", category: "bodyweight", reps: 15, unit: "reps" }),
            ],
        }],
    },
    {
        id: "fran",
        name: "Fran",
        group: "girls",
        track: "crossfit",
        format: "for_time",
        scoreType: "time",
        timeCap: "10 min",
        stimulus: "Sprint curto com carga moderada e alta demanda respiratória.",
        equipment: ["Barra", "Barra fixa"],
        tags: ["benchmark", "thruster", "pull-up"],
        blocks: [{
            name: "Fran",
            workoutType: "wod",
            componentType: "metcon",
            format: "for_time",
            scoreType: "time",
            timeCap: "10 min",
            stimulus: "21-15-9 rápido, preservando padrão técnico.",
            sets: [
                movement({ movementId: "thruster", movement: "Thruster", category: "weightlifting", reps: "21-15-9", unit: "reps", load: "95/65 lb", scaling: { intermediate: "75/55 lb", beginner: "DB thruster leve" } }),
                movement({ movementId: "pull_up", movement: "Pull-up", category: "gymnastics", reps: "21-15-9", unit: "reps", scaling: { intermediate: "Jumping pull-up", beginner: "Ring row" } }),
            ],
        }],
    },
    {
        id: "helen",
        name: "Helen",
        group: "girls",
        track: "crossfit",
        format: "rft",
        scoreType: "time",
        timeCap: "15 min",
        rounds: "3",
        stimulus: "Corrida forte com movimentos simples e pouca pausa.",
        equipment: ["Kettlebell", "Barra fixa"],
        tags: ["benchmark", "run", "kettlebell"],
        blocks: [{
            name: "Helen",
            workoutType: "wod",
            componentType: "metcon",
            format: "rft",
            scoreType: "time",
            timeCap: "15 min",
            rounds: "3",
            sets: [
                movement({ movementId: "run", movement: "Corrida", category: "monostructural", reps: 400, unit: "m" }),
                movement({ movementId: "kettlebell_swing", movement: "Kettlebell Swing", category: "kettlebell", reps: 21, unit: "reps", load: "24/16 kg" }),
                movement({ movementId: "pull_up", movement: "Pull-up", category: "gymnastics", reps: 12, unit: "reps" }),
            ],
        }],
    },
    {
        id: "grace",
        name: "Grace",
        group: "girls",
        track: "crossfit",
        format: "for_time",
        scoreType: "time",
        timeCap: "8 min",
        stimulus: "Barbell cycling rápido com carga moderada.",
        equipment: ["Barra"],
        tags: ["benchmark", "clean and jerk", "barbell"],
        blocks: [{
            name: "Grace",
            workoutType: "wod",
            componentType: "metcon",
            format: "for_time",
            scoreType: "time",
            timeCap: "8 min",
            sets: [
                movement({ movementId: "clean", movement: "Clean & Jerk", category: "weightlifting", reps: 30, unit: "reps", load: "135/95 lb", scaling: { beginner: "Carga leve, técnica consistente" } }),
            ],
        }],
    },
    {
        id: "murph",
        name: "Murph",
        group: "heroes",
        track: "crossfit",
        format: "chipper",
        scoreType: "time",
        timeCap: "60 min",
        stimulus: "Hero WOD longo, alta resistência muscular e cardiovascular.",
        equipment: ["Barra", "Colete"],
        tags: ["hero", "bodyweight", "endurance"],
        blocks: [{
            name: "Murph",
            workoutType: "wod",
            componentType: "metcon",
            format: "chipper",
            scoreType: "time",
            timeCap: "60 min",
            scalingNotes: "Particionar reps, remover colete ou reduzir volume conforme nível.",
            sets: [
                movement({ movementId: "run", movement: "Corrida", category: "monostructural", reps: 1600, unit: "m" }),
                movement({ movementId: "pull_up", movement: "Pull-up", category: "gymnastics", reps: 100, unit: "reps" }),
                movement({ movementId: "push_up", movement: "Push-up", category: "bodyweight", reps: 200, unit: "reps" }),
                movement({ movementId: "air_squat", movement: "Air Squat", category: "bodyweight", reps: 300, unit: "reps" }),
                movement({ movementId: "run", movement: "Corrida", category: "monostructural", reps: 1600, unit: "m" }),
            ],
        }],
    },
    {
        id: "open_24_1_style",
        name: "Open Style 21-15-9",
        group: "open",
        track: "competition",
        format: "for_time",
        scoreType: "time",
        timeCap: "15 min",
        stimulus: "WOD de competição com transições curtas e reps descendentes.",
        equipment: ["Halteres", "Barra"],
        tags: ["open", "competition"],
        blocks: [{
            name: "Open Style",
            workoutType: "wod",
            componentType: "metcon",
            format: "for_time",
            scoreType: "time",
            timeCap: "15 min",
            sets: [
                movement({ movementId: "thruster", movement: "DB Thruster", category: "weightlifting", reps: "21-15-9", unit: "reps", load: "22.5/15 kg" }),
                movement({ movementId: "burpee", movement: "Burpee over DB", category: "bodyweight", reps: "21-15-9", unit: "reps" }),
            ],
        }],
    },
];

export const getWodBenchmarkById = (benchmarkId) =>
    WOD_BENCHMARK_LIBRARY.find(benchmark => benchmark.id === benchmarkId);
